import { RMCCard } from "../../../../../../components/world/rmc/card";
import { AppLayout } from "../../../../../../layout/AppLayout";
import {
  Arrow,
  FundCard,
} from "../../../../../../components/svg/worldSvgs/rmc/Achievements";
import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "../../../../../../components/world/rmc/Button";
import { Input } from "../../../../../../components/world/rmc/input/input";
import { useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import clsx from "clsx";
import { useFlutterwave, closePaymentModal } from "flutterwave-react-v3";
import { UserContext } from "../../../../../../components/context/UseContext";
import { useVerifyCardPayment } from "../../../../../../api/verifyCardPayment";
import { usePaystackPayment } from "react-paystack";
import { Loader } from "../../../../../../components/loader/Loader";
import { RmcContext } from "../../../../../../components/context/RmcContext";
import { useGenerateBrand } from "../../../../../../api/useGenerateBrand";

const FundWalletVia = [
  { label: "Flutterwave", value: "flutterwave" },
  { label: "Paystack", value: "paystack" },
];
export const RmcCardTopUp = () => {
  const navigate = useNavigate();
  const { profile, token } = useContext(UserContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const { verifyCardPayment, loading } = useVerifyCardPayment();
  const { slug, brandId } = useContext(RmcContext);
  const amountParam = searchParams.get("amount");
  const currentStep = searchParams.get("step");
  const [amount, setAmount] = useState(amountParam || "");
  const [method, setMethod] = useState(FundWalletVia[0]);
  // const [cardDetails, setCardDetails] = useState({
  //   cardNumber: "",
  //   expiryDate: "",
  //   cvv: "",
  //   pin: "",
  // });

  // Function to navigate to a specific step
  // const goToStep = (step) => {
  //   setSearchParams({ step });
  // };

  const {
    generateBrand,
    data: brandData,
    loading: isPending,
  } = useGenerateBrand();

  const primaryColor = brandData?.data?.brand?.secondary_color ?? "#FFD700";

  useEffect(() => {
    if (brandId) {
      generateBrand({
        token: token,
        brand_id: brandId,
        is_link: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandId]);

  // Handle back navigation
  const handleBack = () => {
    if (currentStep === "payment-methods") {
      navigate(-1);
    } else {
      navigate(`/worlds/${slug}/achievements?tab=wallet`);
    }
  };

  const handleAmountSubmit = () => {
    if (!amount || amount < 500 || amount > 99999) {
      toast.info("Please enter a valid amount between ₦500 and ₦99,999.");
      return;
    }
    setSearchParams({
      step: "payment-methods",
      amount: amount,
    });
  };

  // Handle input changes
  // const handleCardDetailChange = (field, value) => {
  //   setCardDetails((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };

  const config = {
    public_key: "FLWPUBK_TEST-bb14670461348b5a927827da956ec325-X",
    tx_ref: Date.now(),
    amount: parseFloat(amountParam) || 100,
    currency: "NGN",
    payment_options: "card,mobilemoney,ussd, banktransfer",
    customer: {
      email: profile.email,
      phone_number: profile.phone || "+2347062986206",
      name: `${profile?.first_Name || "Anonymous"} ${
        profile?.last_Name || "User"
      }`,
    },
    customizations: {
      title: "Rmc Wallet Top Up",
      description: "Payment for wallet top up",
      logo: "https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg",
    },
  };

  const paystackConfig = {
    reference: new Date().getTime().toString(),
    email: profile.email,
    amount: parseFloat(amountParam) * 100,
    publicKey: "pk_test_e4ac7acbc8627f70face51c904aaf3171ed824e0",
    channels: ["card", "bank", "ussd", "qr", "bank_transfer"],
  };

  const handleFlutterPayment = useFlutterwave(config);
  const handlePaystackPayment = usePaystackPayment(paystackConfig);

  const handlePayment = () => {
    if (method.value === "flutterwave") {
      handleFlutterPayment({
        callback: async (response) => {
          if (response.status !== "completed") {
            toast.error("Payment failed. Please try again.");
            return;
          } else {
            const isSuccess = await verifyCardPayment(
              response.transaction_id,
              method.value,
            );

            if (isSuccess && !loading) {
              navigate(`/worlds/${slug}/achievements?tab=wallet`);
            }
          }

          closePaymentModal();
        },
        // onClose: () => {},
      });
    } else if (method.value === "paystack") {
      handlePaystackPayment({
        onSuccess: async (response) => {
          if (response.status !== "success") {
            toast.error("Payment failed. Please try again.");
            return;
          } else {
            const isSuccess = await verifyCardPayment(
              response.reference,
              method.value,
            );

            if (isSuccess && !loading) {
              navigate(`/worlds/${slug}/achievements?tab=wallet`);
            }
          }
        },
        onClose: () => {
          // console.log("Payment closed");
        },
      });
    }
  };

  const renderAmountStep = () => (
    <>
      <RMCCard className="my-12">
        <Input
          label="Enter Amount"
          type="number"
          placeholder="500 - 99,999"
          value={amount || amountParam || ""}
          onChange={(e) => {
            const value = e.target.value;
            setAmount(value);
            setSearchParams({
              amount: value,
            });
          }}
          className="relative border-b border-b-[#FFFFFF80]"
          inputClass="bg-transparent !px-5 !text-base"
          leadingIcon={
            <span className="rmc_naira_position top-[3.27rem] !left-1">₦</span>
          }
        />
      </RMCCard>
      <Button
        onClick={handleAmountSubmit}
        text="Fund Account"
        className="!py-[18px] !text-lg !font-semibold"
        style={{ backgroundColor: primaryColor }}
      />
    </>
  );

  // const renderCardDetails = () => (
  //   <RmcCardDetails
  //     cardDetails={cardDetails}
  //     setCardDetails={setCardDetails}
  //     handleCardDetailChange={handleCardDetailChange}
  //     handleCardSubmit={handleCardSubmit}
  //   />
  // );

  const renderPaymentMethods = () => (
    <>
      <div className="my-12 flex flex-col gap-5">
        {FundWalletVia?.map((x, i) => {
          return (
            <RMCCard
              key={i}
              onClick={() => setMethod(x)}
              className={clsx(
                x.value === method.value ? "!border" : "",
                "flex items-center justify-between gap-3 !py-2.5 !pl-2.5 !pr-7 cursor-pointer",
              )}
              style={
                x.value === method.value ? { borderColor: primaryColor } : {}
              }
            >
              <div className="flex items-center gap-2.5">
                <FundCard color={primaryColor} />
                <div>
                  <p className="text-base font-semibold text-white mb-1">
                    {x.label}
                  </p>
                </div>
              </div>
            </RMCCard>
          );
        })}
      </div>
      <Button
        onClick={handlePayment}
        text={
          loading ? <Loader type="bubbles" /> : `Proceed to ${method.label}`
        }
        className={clsx(!loading && "!py-[18px]", " !text-lg !font-semibold")}
        style={{ backgroundColor: primaryColor }}
      />
    </>
  );

  if (isPending) {
    return (
      <div className="h-[100dvh] bg-[#111522] flex items-center justify-center">
        <Loader type="spinningBubbles" color="#fff" />
      </div>
    );
  }

  return (
    <AppLayout noNav bg={"!bg-[#111522]"}>
      <div className="min-h-screen px-4 pt-10">
        <div className="relative flex items-center justify-center">
          <Arrow
            onClick={handleBack}
            stroke="#fff"
            className="text-lg absolute left-0 cursor-pointer rotate-90"
          />
          <p className="font-bold text-xl text-white">Fund Wallet</p>
        </div>

        {currentStep === "payment-methods"
          ? renderPaymentMethods()
          : renderAmountStep()}
      </div>
    </AppLayout>
  );
};
